import React from 'react';
import { Link } from '@inertiajs/react';
import { ChevronRight, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
    label: string;
    href?: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
    className?: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, className = '' }) => {
    const { t } = useTranslation();
    
    return (
        <nav className={`flex items-center space-x-2 text-sm ${className}`} aria-label="Breadcrumb">
            <Link href="/" className="flex items-center text-[#A0A0A0] hover:text-[#505050] dark:hover:text-white">
                <Home size={16} className="mr-1" />
                {t('home.home')}
            </Link>

            {items.map((item, index) => (
                <React.Fragment key={index}>
                    <ChevronRight size={16} className="text-[#A0A0A0]" />
                    {item.href ? (
                        <Link
                            href={item.href}
                            className="truncate text-[#A0A0A0] hover:text-[#505050] dark:hover:text-white"
                        >
                            {item.label}
                        </Link>
                    ) : (
                        <span className="truncate font-medium text-[#505050] dark:text-white">
                            {item.label}
                        </span>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};

export default Breadcrumbs;